import { Box } from '@mui/material'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import Skeleton from '@mui/material/Skeleton'
import SpecialOffer from './SpecialOffer'

const SpecialOfferSkltn = () => {
  return (
      <div>
          <Box className='special-offer-right'>
            <Row className="offer-flight-row">
                <Col xs={12}>
                    <Box className=''>
                        <Skeleton className="" animation="wave" variant="rectangular" width={"100%"} height={50} />
                    </Box>
                </Col>
            </Row>
            <Row className="offer-flight-row">
                <Col xs={12}>
                    <Box className=''>
                        <Skeleton className="" animation="wave" variant="rectangular" width={"100%"} height={50} />
                    </Box>
                </Col>
            </Row>
            <Row className="offer-flight-row">
                <Col xs={12}>
                    <Box className=''>
                        <Skeleton className="" animation="wave" variant="rectangular" width={"100%"} height={50} />
                    </Box>
                </Col>
            </Row>
            <Row className="offer-flight-row">
                <Col xs={12}>
                    <Box className=''>
                        <Skeleton className="" animation="wave" variant="rectangular" width={"100%"} height={50} />
                    </Box>
                </Col>
            </Row>
            <Row className="offer-flight-row">
                <Col xs={12}>
                    <Box className=''>
                        <Skeleton className="" animation="wave" variant="rectangular" width={"100%"} height={50} />
                    </Box>
                </Col>
            </Row>
        </Box>
      </div>
  );
}

export default SpecialOfferSkltn
